import { all, takeEvery, fork, put, select, call } from 'redux-saga/effects'
import actions from './actions'
import {
    getListNotify,
    setNotifyRead,
    setAllNotifyRead,
} from '../../services/apis/NotifyService'
import { getListReportQueryById } from '../../services/apis/ReportAPIServices'
import drawerActions from '../drawer/actions'

function getColumnId(status) {
    if (status === 'Sent') {
        return 'column2'
    }
    if (status === 'Watched') {
        return 'column3'
    }
    if (status === 'Rework') {
        return 'column4'
    }
    if (status === 'Approved') {
        return 'column5'
    }
}
function* saga_setReadAllNotify(action) {
    try {
        const request = yield call(setAllNotifyRead)
        if (request.error.code === 200) {
            yield put(actions.action.getListNotify(1, 10, true))
        }
    } catch (ex) {
        console.error('get list notify error : ', ex.messag)
    }
}
function* saga_getListNotify(action) {
    try {
        const { page_number, page_size, isRefresh } = action.payload
        const request = yield call(getListNotify, page_number, page_size, -1)
        if (request.error.code === 200) {
            console.log('data notify', request.data)
            yield put(
                actions.action.updateTotalIndex(request.total, page_number)
            )
            yield put(actions.action.getListNotifyDone(request.data, isRefresh))
        }
    } catch (ex) {
        console.error('get list notify error : ', ex.messag)
    }
}
function* saga_setReadNotify(action) {
    try {
        const { id } = action.payload
        const request = yield call(setNotifyRead, id)
        console.log('set read notify ok', request)

        if (request.error.code === 200) {
            yield put(actions.action.getListNotify(1, 10, true))
        }
    } catch (ex) {
        console.error('set read notify error: ', ex.messag)
    }
}

function* saga_getDataTaskInNotify(action) {
    try {
        const { id, idOfTask } = action.payload

        const resquest = yield call(getListReportQueryById, id.toString())
        console.log('request get detailTaskById from notify', resquest)
        let reportTask
        let columnid
        if (resquest.error.code === 200) {
            resquest.data.map(report => {
                columnid = getColumnId(report.status_report)
                reportTask = {
                    id: report.report_id,
                    column_id: getColumnId(report.status_report),
                    title: report.title,
                    description: report.content,
                    labels: report.hashtag,
                    due_date: null,
                    assignees: [],
                    attachments: [],
                    comments: [],
                    todos: [],
                    editing: false,
                    created_at: report.created_time,
                    updated_at: '',
                    type: 'report',
                    event: report.event,
                    media: report.media,
                    object: report.object,
                    organ_create: report.organ_create,
                    canEdit: report.status_report === 'Rework' ? true : false,
                    IdOfTask: idOfTask,
                    score: report.score,
                    owner_id: report.owner_id,
                }
            })
            yield put(
                drawerActions.openDrawer({
                    drawerType: 'CARD_DETAILS',
                    drawerProps: {
                        task: { ...reportTask },
                        columnId: columnid,
                    },
                })
            )
        }
    } catch (ex) {
        console.log('saga_getDataTaskInNotify Error : ', ex.message)
    }
}
function* listen() {
    yield takeEvery(actions.type.GET_LIST_NOTIFY, saga_getListNotify)
    yield takeEvery(actions.type.SET_READ_NOTIFY, saga_setReadNotify)
    yield takeEvery(
        actions.type.GET_DATA_TASK_IN_NOTIFY,
        saga_getDataTaskInNotify
    )
    yield takeEvery(actions.type.SET_READ_ALL_NOTIFY, saga_setReadAllNotify)
}

export default function* notifySaga() {
    yield all([fork(listen)])
}
